<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="py-4 fuel_consumption_row_right_section mr-3 pump__bg"
          style="border-radius: 12px; flex: 0 0 97%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="col-md-12"
              style="display: flex; justify-content: center"
            >
              <h4 class="text-center text-white">
                {{
                  !isAssign
                    ? $t("text.retainership.approveRequest")
                    : $t("text.retainership.assignCard")
                }}
              </h4>
            </div>
          </div>
          <div class="transaction_period_text text-center mt-5"></div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <!-- LOADER -->
        <div
          class="showLoaderDiv charts__loader w-full mt-5 rounded-lg w-full"
          style="width: 100% !important; height: 100%"
          v-if="showLoader"
        >
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
        <!-- END LOADER -->

        <div v-if="!showLoader" class="row add_driver_row record__expenses">
          <div class="col-md-12" style="padding-right: 0px">
            <div class="drivers_list">
              <div class="product_summary__wrapper" style="padding: 1px">
                <!-- details of the client's request -->
                <div
                  class="mt-4 ml-4"
                  style="margin-bottom: -30px"
                  v-if="approvalRequest"
                >
                  <p>
                    <span class="mr-2 font-weight-bold">Name:</span>
                    {{ approvalRequest.orderBy }}
                  </p>
                  <p>
                    <span
                      class="mr-2 font-weight-bold"
                      style="margin-top: -50px"
                      >Quantity:</span
                    >
                    {{ approvalRequest && approvalRequest.quantity }}
                  </p>
                </div>
                <!-- select a customer -->
                <div v-if="isAssign">
                  <div
                    style="width: 95%"
                    class="mt-3 mx-auto form_input_section"
                  >
                    <div class="mt-3 input__block">
                      <select v-model="customer">
                        <option value="null" selected disabled>
                          {{ $t("text.retainership.selectClient") }}
                        </option>
                        <option
                          :value="customer.clientId"
                          v-for="(customer, index) in retainers"
                          :key="index"
                        >
                          <span>
                            {{ customer.name }}
                          </span>
                        </option>
                      </select>
                    </div>
                  </div>

                  <div
                    style="width: 95%"
                    class="mt-3 mx-auto form_input_section"
                  >
                    <div class="mt-3 input__block">
                      <select v-model="chargeMode">
                        <option value="selectChargeMode" selected disabled>
                          {{ $t("text.retainership.selectChargeMode") }}
                        </option>

                        <option value="0">
                          {{ $t("text.retainership.billClient") }}
                        </option>

                        <option value="1">
                          {{ $t("text.retainership.dontBill") }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="price_change_form_section mt-5">
                  <form>
                    <div class="row mt-5 justify-content-center;">
                      <div class="col-md-12">
                        <label>{{ $t("text.retainership.cardList") }}</label>
                        <div class="price_change_input_wrapper">
                          <div
                            @click="toggleBranchListDropdown"
                            style="padding: 5px"
                          >
                            <vue-tags-input
                              v-model="tag"
                              :tags="tags"
                              @tags-changed="(newTags) => (tags = newTags)"
                            />
                          </div>

                          <div class="">
                            <div class="search__wrapper">
                              <div class="row align-items-center">
                                <div class="col-md-10">
                                  <input
                                    type="search"
                                    :placeholder="
                                      $t('text.cUsers.createUser.search')
                                    "
                                    v-model="searchInp"
                                  />
                                </div>
                                <div class="col-md-2">
                                  <i
                                    class="fa fa-search"
                                    aria-hidden="true"
                                    style="color: #b6b6b6"
                                  ></i>
                                </div>
                              </div>
                            </div>
                            <div
                              class="row mt-3"
                              style="width: 100%; margin: 0 auto"
                            >
                              <div class="col-md-4">
                                <div classs="">
                                  <b-form-checkbox
                                    id="selectAll"
                                    v-model="selectAll"
                                    class="sec_text_color"
                                  >
                                    {{ $t("text.retainership.selectAllCards") }}
                                  </b-form-checkbox>
                                </div>
                              </div>
                            </div>
                            <div
                              class="row justify-content-center mt-3"
                              style="width: 100%; margin: 0 auto"
                            >
                              <div class="col-md-4">
                                <div class="">
                                  <b-form-group
                                    label=""
                                    v-on:click.native="toggleChckBox($event)"
                                  >
                                    <b-form-checkbox-group
                                      v-model="selected"
                                      :options="filteredList"
                                      name="flavour-2a"
                                      :disabled="disableCheckbox"
                                      stacked
                                    >
                                    </b-form-checkbox-group>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <b-form-group
                                  label=""
                                  v-on:click.native="toggleChckBox($event)"
                                >
                                  <b-form-checkbox-group
                                    v-model="selected"
                                    :options="filteredList2"
                                    name="flavour-2a"
                                    stacked
                                    :disabled="disableCheckbox"
                                  >
                                  </b-form-checkbox-group>
                                </b-form-group>
                              </div>
                              <div class="col-md-4">
                                <b-form-group
                                  label=""
                                  v-on:click.native="toggleChckBox($event)"
                                >
                                  <b-form-checkbox-group
                                    v-model="selected"
                                    :options="filteredList3"
                                    name="flavour-2a"
                                    stacked
                                    :disabled="disableCheckbox"
                                  >
                                  </b-form-checkbox-group>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row align-items-center mt-5 justify-content-center update_price_btn_divs"
                    >
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-12">
                            <!-- approve request -->
                            <button
                              v-if="!isAssign"
                              class="save__btn record_expense_btn mr-2 btn_primary_color"
                              style="width: 100%"
                              @click="approveRequest"
                              :disabled="isButtonDisabled ? true : null"
                              :style="[
                                isButtonDisabled
                                  ? { cursor: 'not-allowed' }
                                  : { cursor: 'pointer' },
                              ]"
                            >
                              {{ $t("text.retainership.approveRequest") }}
                              <span>
                                <img
                                  src="@/assets/img/git_loader.gif"
                                  style="display: none"
                                  width="25px"
                                  class="loader ml-2"
                                />
                              </span>
                            </button>
                            <!--  -->

                            <!-- assign cards directly to client -->
                            <button
                              v-if="isAssign"
                              class="save__btn record_expense_btn mr-2 btn_primary_color"
                              style="width: 100%"
                              @click="assignCard"
                              :disabled="isButtonDisabled ? true : null"
                              :style="[
                                isButtonDisabled
                                  ? { cursor: 'not-allowed' }
                                  : { cursor: 'pointer' },
                              ]"
                            >
                              {{ $t("text.retainership.assignCard") }}
                              <span>
                                <img
                                  src="@/assets/img/git_loader.gif"
                                  style="display: none"
                                  width="25px"
                                  class="loader ml-2"
                                />
                              </span>
                            </button>
                            <!--  -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import VueTagsInput from "@johmun/vue-tags-input";
import TableLoader from "@/components/tableLoader/index";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Retainership  :: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    VueTagsInput,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      chargeMode: "selectChargeMode",
      isAssign: this.$route.query.assign,
      customer: null,
      retainers: [],
      numberOfCards: 0,
      requestId: this.$route.query.requestId,
      approvalRequest: null,
      disableCheckbox: false,

      usedLang: this.$store.getters.getLanguage,
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      selected: [],
      date_theme: "purple",
      priceVal: "",
      options: [],
      options2: [],
      options3: [],
      theme: "#370F70",
      combinedOptions: [],
      backgroundUrl,

      token: null,
      userInfo: JSON.parse(localStorage.getItem("userDetails")),

      tag: "",
      tags: [],
      company: null,
      cardBackgroundUrl,
      searchInp: "",
      prodArray: [],
      recentlyUpdated: [],
      showUpdateModal: false,
      price: "",
      branches: [],
      prodList: [],
      showAll: false,
      zone: this.$tc("text.priceManagement.selectZone", 2),
      product: this.$t("text.priceManagement.selectProductSmall"),
      showLoader: false,
      isButtonDisabled: null,
      activeTab: "change_price",
      showBranchListDropDown: false,
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      priceChangeLogLoader: false,
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getCards();

      if (this.isAssign) {
        this.getRetainerships();
      } else {
        this.getCardRequests();
      }
      // this.getBranches();
    }

    this.getToday();

    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
    filteredList() {
      const sortedList = [...this.options];

      sortedList.sort((a, b) => {
        return a.expiryDate > b.expiryDate ? 1 : -1;
      });

      return sortedList.filter((ch, i) => {
        return ch.text.toLowerCase().includes(this.searchInp);
      });
    },
    filteredList2() {
      const sortedList = [...this.options2];
      sortedList.sort((a, b) => {
        return a.expiryDate > b.expiryDate ? 1 : -1;
      });
      return sortedList.filter((ch, i) => {
        return ch.text.toLowerCase().includes(this.searchInp);
      });
    },
    filteredList3() {
      const sortedList = [...this.options3];
      sortedList.sort((a, b) => {
        return a.expiryDate > b.expiryDate ? 1 : -1;
      });

      return sortedList.filter((ch, i) => {
        return ch.text.toLowerCase().includes(this.searchInp);
      });
    },
    selectAll: {
      get: function () {},
      set: function (value) {
        let combinedArray;
        let selected = [];
        let totalCards = [...this.options, ...this.options2, ...this.options3];

        if (
          this.approvalRequest &&
          this.approvalRequest.quantity <= this.numberOfCards
        ) {
          combinedArray = totalCards.splice(0, this.approvalRequest.quantity);
        } else {
          combinedArray = totalCards;
        }

        if (!value) {
          this.selected = selected;
          this.tags = selected;
          return;
        }
        if (value) {
          combinedArray.forEach(function (opt) {
            selected.push(opt.value);
          });
          this.selected = selected;
          this.tags = selected;
        }
      },
    },
    userDetails: {
      get() {
        const user = localStorage.getItem("userDetails")
          ? JSON.parse(localStorage.getItem("userDetails"))
          : null;

        if (user) {
          if (!user.roles) {
            if (user.role) {
              user.roles = user.role.split(",");
              localStorage.setItem("userDetails", JSON.stringify(user));
            }
          }
        }
        return user;
      },
      set(value) {},
    },
  },
  watch: {
    // searchInp(text) {
    //   if (text !== null) {

    //     setTimeout(() => {
    //       this.getCards();
    //     }, 500);
    //   }
    // },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getPriceLog();
      }
    },
    company(company) {
      if (company !== null) {
        this.getCards();

        if (this.isAssign) {
          this.getRetainerships();
        } else {
          this.getCardRequests();
        }
      }
    },
    tags: function (newTags, oldTags) {
      let newSelectedArray = [];

      if (newTags.length === oldTags.length) {
        newTags.forEach((tg) => {
          newSelectedArray.push(tg);
        });
        this.selected = newSelectedArray;
      } else {
        newTags.forEach((tg) => {
          newSelectedArray.push(tg.text);
        });
      }
      if (
        this.approvalRequest &&
        this.approvalRequest.quantity <= newSelectedArray.length
      ) {
        this.disableCheckbox = true;
      } else {
        this.disableCheckbox = false;
      }
    },
    value: function () {
      if (this.value !== "") {
        this.$refs.date_label.style.display = "none";
      }
    },
  },
  methods: {
    //Requests

    // get registered retainership companies
    getRetainerships() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/Clients/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          this.showLoader = false;

          this.retainers = response.data.data;
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    //asign cards to client directly
    assignCard(e) {
      e.preventDefault();

      let companyID;
      if (localStorage.getItem("companyDetails") !== null) {
        companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      }

      //changing content type
      const config = configObject.authConfig({ isRemis: true });
      config.headers["Content-Type"] = "application/json";

      if (!this.customer) {
        this.$toast.open({
          message: this.$t("text.retainership.selectClient"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (!this.chargeMode || this.chargeMode === "selectChargeMode") {
        this.$toast.open({
          message: this.$t("text.retainership.selectChargeMode"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        clientId: this.customer,
        cards: this.tags,
        chargeMode: Number(this.chargeMode),
      };
      $(".loader").show();
      this.isButtonDisabled = true;

      this.axios
        .post(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/addClientCard/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          data,
          config
        )
        .then((response) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: this.$t("text.retainership.assignedSuccess"),
            type: "success",
            duration: 5000,
          });
          this.getCards();
          this.tags = [];
          // this.$eventHub.$emit("getRetainerships");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });

          console.log(error);
        });
    },

    //approve request
    approveRequest(e) {
      e.preventDefault();
    
      let companyID;
      if (localStorage.getItem("companyDetails") !== null) {
        companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      }

      //changing content type
      const config = configObject.authConfig({ isRemis: true });
      config.headers["Content-Type"] = "application/json";

      let data = {
        requestId: this.requestId,
        cards: this.tags,
      };

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .post(
          `${
            configObject.remisBaseUrl
          }/D/Retainership/Customer/ProcessCardRequest/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          data,
          config
        )
        .then((response) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: this.$t("text.retainership.assignedSuccess"),
            type: "success",
            duration: 5000,
          });

          this.$router.push({
            name: "card-request",
            query: {
              companyId: this.$route.query.companyId,
            },
          });

          this.$eventHub.$emit("getRetainerships");
        })
        .catch((error) => {
          this.showLoader = false;
          $(".loader").hide();

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }
          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });

          console.log(error);
        });
    },

    //get card requests
    getCardRequests() {
      if (localStorage.getItem("companyDetails") !== null) {
        companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      }
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/CardRequests/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,

          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          response.data.data.forEach((request) => {
            request.orderDate = this.$moment(request.orderDate).format(
              "YYYY/MM/DD"
            );
          });

          this.approvalRequest = response.data.data.filter((request) => {
            return request.id === this.requestId;
          })[0];
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });

          console.log(error.response);
        });
    },

    //get cards
    getCards() {
      // this.showLoader = true;

      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/Cards/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          // ?query=${this.searchInp}
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          if (response.data.data.cards) {
            this.unissuedCards = response.data.data.cards.filter((card) => {
              return !card.clientId;
            });
            this.issuedCards = response.data.data.cards.filter((card) => {
              return card.clientId;
            }).length;
          }
          this.unissuedCards.sort((a, b) => {
            return a.expiryDate > b.expiryDate ? 1 : -1;
          });

          this.numberOfCards = this.unissuedCards.length;

          this.unissuedCards.forEach((el) => {
            el.text = el.cardNumber;
            el.value = el.cardNumber;
          });

          let copiedResponse = [...this.unissuedCards];
          let options = [];
          let options2 = [];
          let options3 = [];

          copiedResponse.forEach((el, index) => {
            let dataLengthFirstOneThird = parseInt(copiedResponse.length / 3);

            if (index <= dataLengthFirstOneThird) {
              options.push(el);
            }
          });

          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1
          );

          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.combinedOptions = [...options, ...options2, ...options3];

          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.totalCards = response.data.data.length;

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          this.$toast.open({
            message: error.response.data.title,
            type: "error",
            duration: 5000,
          });
        });
    },

    //utilities

    sortComparer(reference, comparer) {
      reference = this.$moment(reference, "DD/MM/YYYY").format();
      comparer = this.$moment(comparer, "DD/MM/YYYY").format();
      if (reference < comparer) {
        return -1;
      } else if (reference > comparer) {
        return 1;
      } else {
        return 0;
      }
    },
    sortComparer2(reference, comparer) {
      reference = this.revertNumber(reference);
      comparer = this.revertNumber(comparer);
      return reference - comparer;
    },
    excelQueryCellInfo(args) {
      if (
        args.column.field == "currentPrice" ||
        args.column.field == "previousPrice"
      ) {
        args.value = this.revertNumber(args.value);
      }
    },
    checkViewOnly() {
      this.isButtonDisabled = this.$store.getters.getViewOnly;
    },

    rowDataBound: function (args) {
      if (args.data["priceChanged"] === true) {
        args.row.cells[3].style.color = "red";
      }
      if (args.data["priceChanged"] === false) {
        args.row.cells[3].style.color = "green";
      }
    },
    hideButton($event) {
      $event.preventDefault();
      $event.target.style.display = "none";
      this.$refs.update_later_div.style.display = "block";
    },

    toggleChSelectAllBox($event) {
      if ($event.target.checked) {
        $event.target.checked = false;
      } else {
        $event.target.checked = true;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toggleShowAll(event) {
      this.activeTab = "price_change_log";
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    activateTab(tab) {
      this.activeTab = tab;
      if (this.activateTab === "price_change_log") {
        this.getPriceLog();
      }
    },
    toggleChckBox($event) {
      if (!this.disableCheckbox) {
        if ($event.target.checked) {
          if (!this.tags.includes($event.target.value)) {
            this.tags.push($event.target.value);
            const getIndex = this.selected.indexOf($event.target.value);
            if (getIndex === -1) {
              this.selected.push($event.target.value);
            } else {
              this.selected.splice(getIndex, 1);
            }
          }
        } else {
          if (this.tags.includes($event.target.value)) {
            const getIndex = this.tags.indexOf($event.target.value);
            this.tags.splice(getIndex, 1);
          }
        }
      }
    },
    getToday() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      hours = hours < 10 ? "0" + hours : hours;
      var strTime = hours + ":" + minutes + " " + ampm;
      // var strTime = hours + ':' + minutes;

      let todaysDate = [year, month, day].join("-") + " " + strTime;
      this.schedulePriceChangeDate = todaysDate;
    },
    showModal($event, period) {
      $event.preventDefault();
      if (this.product === this.$t("text.priceManagement.selectProductSmall")) {
        this.$toast.open({
          message: this.$t("text.errors.productMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.priceVal) {
        this.$toast.open({
          message: this.$t("text.errors.priceFieldMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.priceVal <= 0) {
        this.$toast.open({
          message: this.$t("text.errors.invalidPrice"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.selected.length < 1) {
        this.$toast.open({
          message: this.$t("text.priceManagement.selectBranch"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      this.datePeriod = period;
      this.showUpdateModal = true;
      if (this.userDetails.roles.includes("SupportAdmin")) {
        this.sendTokenMail();
      }
    },

    hidePriceSheduleDiv() {
      this.$refs.update_later_div.style.display = "none";
      this.$refs.update_later_btn_1.style.display = "block";
    },

    getBranches() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          let copiedResponse = [...response.data];
          let options = [];
          let options2 = [];
          let options3 = [];
          copiedResponse.forEach((br, index) => {
            let dataLengthFirstOneThird = copiedResponse.length / 3;
            if (index <= dataLengthFirstOneThird) {
              options.push(br);
            }
          });
          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1
          );
          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.combinedOptions = [...options, ...options2, ...options3];
          let index = 0;
          response.data.sort((a, b) => {
            if (a.dealerName === b.dealerName) {
              return a.name > b.name ? 1 : -1;
            }
            return a.dealerName > b.dealerName ? 1 : -1;
          });
          response.data.forEach((branch) => {
            index++;
            branch.index = index;
            branch.text = branch.name;
            branch.value = branch.name.toLowerCase();
          });
          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.options.sort((a, b) => {
            if (a.dealerName === b.dealerName) {
              return a.text > b.text ? 1 : -1;
            }
            return a.dealerName > b.dealerName ? 1 : -1;
          });
        })
        .catch((error) => {});
    },

    convertThousand(request) {
      if (request === null || request === "null") {
        return "0.00";
      }
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getZones() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Zones/Company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          response.data.forEach((zone, index) => {
            zone.index = index + 1;
            const moment = zone.date
              .split("T")[0]
              .split("-")
              .reverse()
              .join("-");
            zone.date = this.$moment(moment, "DD-MM-YYYY").format(
              "D MMMM, YYYY"
            );
          });
          this.showLoader = false;
          this.zones = response.data;
        })
        .catch((error) => {});
    },

    getPriceLog() {
      this.showLoader = true;
      this.priceChangeLogLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/PriceChangeLog/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.priceChangeLogLoader = false;
          response.data.sort((a, b) => {
            return a.name > b.companyName ? 1 : -1;
          });
          response.data.sort((a, b) => {
            return a.product > b.product ? 1 : -1;
          });
          response.data.forEach((x, index) => {
            x.index = index + 1;
            x.date = this.$moment(x.date).format("MMMM Do YYYY, h:mma");
            x.currentPrice = this.convertThousand(x.currentPrice);
            x.previousPrice = this.convertThousand(x.previousPrice);
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.priceChangeLogLoader = false;
          this.showLoader = false;
        });
    },
    toggleBranchListDropdown() {
      this.showBranchListDropDown = !this.showBranchListDropDown;
    },
    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },
  },
};
</script>

<style scoped>
@keyframes flicker {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
.flicker-text {
  animation: flicker 3s infinite;
}
</style>
